import React from 'react';
import { ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import './answerCard.stylton.scss';

const AnswerCardSkeleton: React.FC<ConnectedProps<typeof connector>> = function (
    props: ConnectedProps<typeof connector>,
) {
    return (
        <div className="ucheck-kiosk-answer-card-skeleton">
            <div
                style={{
                    width: (20 + Math.random() * 20).toString() + '%',
                }}
                className="items ucheck-skeleton"
            />
            <div className="end-line">
                <div
                    style={{
                        width: (25 + Math.random() * 25).toString() + '%',
                    }}
                    className="item1 ucheck-skeleton"
                />
                <div
                    style={{
                        width: (20 + Math.random() * 40).toString() + '%',
                    }}
                    className="item2 ucheck-skeleton"
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({});

const connector = connect(mapStateToProps);
export default connector(AnswerCardSkeleton);
